import React, { useState, useEffect } from "react";
import DOMPurify from "dompurify";
import Hospital from "../../../assets/images/comman/hospital.png";
import Logo from "../../../assets/images/logo.svg";
import Scanner from "../../../assets/images/comman/scanner.png";
import Logo1 from "../../../assets/images/comman/nationalHealthAuthrity.svg";
import Logo2 from "../../../assets/images/comman/pranAiLogo.svg";
import Logo3 from "../../../assets/images/comman/ABDM.svg";
import Logo4 from "../../../assets/images/comman/digitalMission.svg";
import ToastContainer, {
  useToast,
} from "../../../components/common/ToastContainer";

const HospitalDetails = () => {
  const { toasts, removeToast, showSuccess, showError, showWarning } = useToast();
  const [qrCode, setQrCode] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [payload, setPayload] = useState(null);

  useEffect(() => {
    const fetchQRCode = async () => {
      try {
        setLoading(true);

        const response = await fetch(
          `${process.env.REACT_APP_M2}/opd/qr-code?counterId=1`,
          {
            method: "GET",
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
            },
          },
        );

        const data = await response.json();

        if (data.status === "success") {
          setQrCode(data.data.qrCode);
          setPayload(data.data.payload);
        } else {
          setError("Failed to fetch QR code");
        }
      } catch (err) {
        console.error("Error fetching QR code:", err);
        setError(err.message || "Failed to fetch QR code");
      } finally {
        setLoading(false);
      }
    };

    fetchQRCode();
  }, []);

  // Print QR Code
  const handlePrint = () => {
    if (!qrCode) {
      showWarning("QR Code not available");
      return;
    }

    const printWindow = window.open("", "_blank");
    if (!printWindow) return;

    const printHtml = `
      <!DOCTYPE html>
      <html>
        <head>
          <title>Print QR Code</title>
          <style>
            body {
              margin: 0;
              padding: 20px;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              font-family: Arial, sans-serif;
            }
            .print-container {
              text-align: center;
            }
            img {
              max-width: 400px;
              height: auto;
              margin: 20px 0;
            }
            .info {
              margin-top: 20px;
              font-size: 14px;
              color: #666;
            }
            @media print {
              body {
                margin: 0;
              }
            }
          </style>
        </head>
        <body>
          <div class="print-container">
            <h2>Hospital QR Code</h2>
            <img src="${qrCode}" alt="QR Code" />
            ${payload ? `<div class="info">Scan to access: ${payload}</div>` : ""}
          </div>
        </body>
      </html>
    `;
    printWindow.document.write(DOMPurify.sanitize(printHtml));
    printWindow.document.close();
    printWindow.focus();

    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 250);
  };

  // Share QR Code
  const handleShare = async () => {
    if (!qrCode && !payload) {
      showWarning("Nothing to share");
      return;
    }

    // Check if Web Share API is available
    if (navigator.share) {
      try {
        // Try to share with Web Share API
        const shareData = {
          title: "Hospital QR Code",
          text: "Scan this QR code to access hospital details",
          url: payload || window.location.href,
        };

        await navigator.share(shareData);
      } catch (err) {
        if (err.name !== "AbortError") {
          console.error("Error sharing:", err);
          // Fallback to copying link
          copyToClipboard();
        }
      }
    } else {
      // Fallback: Copy to clipboard
      copyToClipboard();
    }
  };

  // Copy link to clipboard
  const copyToClipboard = () => {
    const textToCopy = payload || window.location.href;

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(textToCopy)
        .then(() => {
          showSuccess("Link copied to clipboard!");
        })
        .catch((err) => {
          console.error("Failed to copy:", err);
          showError("Failed to copy link");
        });
    } else {
      // Fallback for older browsers
      const textArea = document.createElement("textarea");
      textArea.value = textToCopy;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand("copy");
        showSuccess("Link copied to clipboard!");
      } catch (err) {
        showError("Failed to copy link");
      }
      document.body.removeChild(textArea);
    }
  };
  return (
    <>
      <div className="container-fluid">
        <div className="hospitalDetailsPage">
          <div className="hospitalDetailsRow">
            <div className="hospitalImgSection">
              <img src={Hospital} />
            </div>
            <div className="hospitalDetailsContent">
              <div className="hospitalAddress">
                <img src={Logo} />
              </div>
              <div className="hospitalScanner">
                <div className="scannerHeader">
                  <img src={Logo1} />
                  <img src={Logo2} />
                  <img src={Logo3} />
                  <img src={Logo4} />
                </div>
                <div className="scannerSection">
                  {loading ? (
                    <div className="text-center py-4">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      <p className="mt-2">Loading QR Code...</p>
                    </div>
                  ) : error ? (
                    <div className="alert alert-danger">
                      <strong>Error:</strong> {error}
                    </div>
                  ) : qrCode ? (
                    <img src={qrCode} alt="QR Code" />
                  ) : (
                    <img src={Scanner} alt="Scanner" />
                  )}
                </div>
                <div className="scannerAction">
                  <button
                    className="print"
                    onClick={handlePrint}
                    disabled={loading || !qrCode}
                  >
                    Print
                  </button>
                  <button
                    className="share"
                    onClick={handleShare}
                    disabled={loading || (!qrCode && !payload)}
                  >
                    Share
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer toasts={toasts} removeToast={removeToast} />
    </>
  );
};

export default HospitalDetails;
